import { defineStore } from "pinia";

export const useFormStore = defineStore({
  id: "Form",
  state: () => {
    return {
      parentAjaxParamsCorrespondingTable: {},
    };
  },

  actions: {
    addChildrenToParentAjaxParamsCorrespondingTable(newChildName, value, fieldName) {
      if (!this.parentAjaxParamsCorrespondingTable[newChildName]) {
        this.parentAjaxParamsCorrespondingTable[newChildName] = {};
      }
      this.parentAjaxParamsCorrespondingTable[newChildName][fieldName] = value;
    },

    resetParentAjaxParamsCorrespondingTable() {
      this.parentAjaxParamsCorrespondingTable = {};
    },
  },
});
